import request from '@/util/request';
import qs from 'qs';

/* 系统字典 */
export const getDictApi = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

/* 床位类型 - 分页接口 */
export const getTypePageListApi = (params, options) =>
  request.get('/api/nursing/bed/type/page', Object.assign({}, options, { params }));

/* 床位类型 - 新增 */
export const addTypeApi = (params, options) =>
  request.post('/api/nursing/bed/type/save', params, options, { ContentType: 'application/json' });

/* 床位类型 - 修改 */
export const updateTypeApi = (params, options) =>
  request.post('/api/nursing/bed/type/update', params, options, {
    ContentType: 'application/json',
  });

/* 床位类型 - 删除 */
export const removeTypeApi = (params, options) =>
  request.post('/api/nursing/bed/type/remove', qs.stringify(params), options);

/* 床位类型 - 下拉 */
export const getTypeListApi = (params, options) =>
  request.get('/api/nursing/bed/type/list', Object.assign({}, options, { params }));

/* 楼房管理 - 分类树 */
export const getBuildingTreeApi = (params, options) =>
  request.get('/api/nursing/common/tree-list', Object.assign({}, options, { params }));

/* 楼房管理 - 楼栋 - 分页 */
export const getBuildingPageListApi = (params, options) =>
  request.get('/api/nursing/building/page', Object.assign({}, options, { params }));

/* 楼房管理 - 楼栋 - 新增 */
export const addBuildingApi = (params, options) =>
  request.post('/api/nursing/common/save-building', params, options, {
    ContentType: 'application/json',
  });

/* 楼房管理 - 楼栋 - 修改 */
export const updateBuildingApi = (params, options) =>
  request.post('/api/nursing/building/update', params, options);

/* 楼房管理 - 楼栋 - 删除 */
export const removeBuildingApi = (params, options) =>
  request.post('/api/nursing/building/remove', qs.stringify(params), options);

/* 楼房管理 - 楼层 - 分页 */
export const getFloorPageListApi = (params, options) =>
  request.get('/api/nursing/building/floor/page', Object.assign({}, options, { params }));

/* 楼房管理 - 楼层 - 新增 */
export const addFloorApi = (params, options) =>
  request.post('/api/nursing/common/save-floor', params, options, {
    ContentType: 'application/json',
  });

/* 楼房管理 - 楼层 - 修改 */
export const updateFloorApi = (params, options) => request.post('/api', params, options);

/* 楼房管理 - 楼层 - 删除 */
export const removeFloorApi = (params, options) =>
  request.post('/api/nursing/common/remove-floor', qs.stringify(params), options);

/* 楼房管理 - 房间 - 分页 */
export const getRoomPageListApi = (params, options) =>
  request.get('/api/nursing/room/page', Object.assign({}, options, { params }));

/* 楼房管理 - 房间 - 新增 */
export const addRoomApi = (params, options) =>
  request.post('/api/nursing/common/save-room', params, options, {
    ContentType: 'application/json',
  });

/* 楼房管理 - 房间 - 修改 */
export const updateRoomApi = (params, options) => request.post('/api/nursing/room/update', params, options);

/* 楼房管理 - 房间 - 删除 */
export const removeRoomApi = (params, options) =>
  request.post('/api/nursing/common/remove-room', qs.stringify(params), options);

/* 楼房管理 - 床位 - 分页 */
export const getBedPageListApi = (params, options) =>
  request.get('/api/nursing/bed/page', Object.assign({}, options, { params }));

/* 楼房管理 - 床位 - 新增 */
export const addBedApi = (params, options) =>
  request.post('/api/nursing/common/save-bed', params, options, {
    ContentType: 'application/json',
  });

/* 楼房管理 - 床位 - 修改 */
export const updateBedApi = (params, options) => request.post('/api/nursing/bed/update', params, options);

/* 楼房管理 - 床位 - 删除 */
export const removeBedApi = (params, options) =>
  request.post('/api/nursing/common/remove-bed', qs.stringify(params), options);
